var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader",class:`loader ${_vm.type === 'overlay' ? 'overlay' : ''}`},[_c('div',{staticClass:"loader-items"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary","size":"64"}}),_c('div',{staticClass:"loader-text"},[_vm._v(" "+_vm._s(_vm.text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }